<template>
	<component
		:is="tag"
		:data-kt-menu-trigger="trigger"
		:data-kt-menu-placement="placement"
		data-kt-menu-attach="parent"
		v-bind="triggerAttrs"
		:class="triggerClasses"
		ref="parentRef"
	>
		<slot name="trigger"></slot>
	</component>

	<div
		ref="menuElementRef"
		class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary w-fit"
		:class="menuClasses"
		data-kt-menu="true"
		@click="onItemClicked"
	>
		<slot></slot>
	</div>
</template>

<script setup>
import { onUnmounted } from 'vue';
import { onMounted, ref } from 'vue';

const props = defineProps({
	tag: {
		type: String,
		default: 'div',
	},
	triggerClasses: {
		type: String,
		default: '',
	},
	menuClasses: {
		type: String,
		default: '',
	},
	trigger: {
		type: String,
		default: 'click',
	},
	placement: {
		type: String,
		default: () => {
			const isRTL = (localStorage.getItem('lang') || 'en') == 'ar';
			return isRTL ? 'bottom-start' : 'bottom-end';
		},
	},
	triggerAttrs: {
		type: Object,
		default: () => ({}),
	},
	closeWhenClickInside: {
		type: Boolean,
		default: true,
	},
	useShowForOpen: {
		type: Boolean,
		default: false,
	},
});

const menuElementRef = ref(null);
const parentRef = ref(null);
const emit = defineEmits(['open', 'close']);

const intersectionObserver = new IntersectionObserver((entries) => {
	if (entries.length == 0) return;
	if (!entries[0].isIntersecting) {
		close();
	}
});

const onItemClicked = (e) => {
	if (e.target.tagName == 'INPUT') return;

	if (props.closeWhenClickInside) {
		const menu = KTMenu.getInstance(menuElementRef.value);
		menu.hide();
	}
};

const open = () => {
	const menu = KTMenu.getInstance(menuElementRef.value);
	if (props.useShowForOpen) {
		menuElementRef.value.classList.add('show');
		menuElementRef.value.classList.add('tw-absolute');
	} else menu.show(parentRef.value);
};
const close = () => {
	const menu = KTMenu.getInstance(menuElementRef.value);
	if (props.useShowForOpen) {
		menuElementRef.value.classList.remove('show');
		menuElementRef.value.classList.remove('tw-absolute');
	} else menu.hide();
};

onMounted(() => {
	KTMenu.createInstances();
	const menu = KTMenu.getInstance(menuElementRef.value);
	menu?.on('kt.menu.dropdown.shown', () => {
		emit('open');
	});
	menu?.on('kt.menu.dropdown.hidden', () => {
		emit('close');
	});
	intersectionObserver.observe(parentRef.value);
});

onUnmounted(() => {
	intersectionObserver.disconnect();
});

defineExpose({
	open,
	close,
});
</script>

<style lang="scss" scoped>
.w-fit {
	width: fit-content;
}
</style>
